import { FC, useRef, useState } from 'react'
import { Box, Icon, IconButton, Tooltip } from '@revolut-internal/ui-kit'

import { AssistantChatMessageRating } from 'lib/apiClient'
import { ChatMessageActionItem } from 'components/ChatMessageActionItem/ChatMessageActionItem'

interface IChatFeedbackFeedbackActionProps {
  value: AssistantChatMessageRating
  visible: boolean
  active: boolean
  disabled: boolean
  onClick: VoidFunction
}

export const ChatFeedbackFeedbackAction: FC<IChatFeedbackFeedbackActionProps> = ({
  value,
  visible,
  active,
  disabled,
  onClick,
}) => {
  const tooltipRef = useRef(null)
  const [tooltipOpen, setTooltipOpen] = useState(false)

  if (!visible) {
    return null
  }

  const iconColor = active ? 'grey-tone-50' : 'grey-tone-20'
  const iconName =
    value === AssistantChatMessageRating.ThumbUp ? 'SocialLike' : 'SocialDislike'
  const label =
    value === AssistantChatMessageRating.ThumbUp ? 'Good response' : 'Poor response'

  const handleClick = () => {
    setTooltipOpen(false)
    onClick()
  }

  return (
    <>
      <ChatMessageActionItem
        iconOnly
        useIcon={
          <IconButton
            use={Box}
            size={16}
            useIcon={<Icon name={iconName} color={iconColor} size={16} />}
            useHoverIcon={!active && <Icon name={iconName} color="accent" size={16} />}
          >
            {label}
          </IconButton>
        }
        aria-label={label}
        onClick={!active && !disabled ? handleClick : undefined}
        onMouseOver={() => setTooltipOpen(true)}
        onMouseLeave={() => setTooltipOpen(false)}
        ref={tooltipRef}
      >
        {label}
      </ChatMessageActionItem>
      <Tooltip anchorRef={tooltipRef} open={tooltipOpen}>
        {label}
      </Tooltip>
    </>
  )
}
